import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import logo from './MAP_Logo.png';
import { useRoutes, navigate } from 'hookrouter';
import { requirePropFactory } from '@material-ui/core';
import Routes from '../routes/routes';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },

  menuButton: {
    marginRight: theme.spacing(2),
  },

  title: {
    flexGrow: 1,
    textAlign: 'start',
    fontWeight: 600,
  },

  active: {
    color: 'white',
    textDecoration: 'none',
    border: 'black',
    fontWeight: 'bolder',
    '&:hover': {
      textDecoration: 'underlined',
      color: 'white',
    },
  },

  img: {
    display: 'block',
    maxWidth: 300,
    maxHeight: 75,
  },

  borderSelectTeamsBtn: {
    border: 'solid 1px',
    color: '#ffa502',
  },

  notificationColor: {
    color: '#f44336',
  },

  blackBar: {
    backgroundColor: '#292c38',
  },

  bellbtn: {
    color: '#f44336',
    '&:hover': {
      background: '#e6c7c5',
    },
  },

  avatarProps: {
    background: 'orange',
    '&:hover': {
      background: '#b87d11',
    },
  },

  noBorder: {
    border: 0,
    '&:hover:before,&:hover:after,&:after,&:before': {
      border: '0!important',
    },
  },
}));

export default function NavBar() {
  useRoutes(Routes);
  const classes = useStyles();
  const [isAuthenticated, setAuth] = useState(false);

  const handleSessionout = () => {
    setAuth(false);
  };

  const handleRoute = (evt) => {
    // eslint-disable-next-line default-case
    switch (evt) {
      case 'Home':
        navigate('/home/');
        break;
      case 'Search':
        navigate('/' + localStorage.getItem('userId'));
        break;
    }
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.blackBar}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            <img className={classes.img} src={logo} alt="Company LOGO" />
          </Typography>

          {(!('auth' in localStorage) ||
            localStorage.getItem('auth') === 'false' ||
            localStorage.getItem('auth') === undefined) && (
            <Button
              className={classes.active}
              onClick={() => {
                navigate('/', true);
              }}
            >
              {' '}
              Login{' '}
            </Button>
          )}
          {'auth' in localStorage && localStorage.getItem('auth') === 'true' && (
            <Button className={classes.active} onClick={() => handleRoute('Home')}>
              {' '}
              Home{' '}
            </Button>
          )}
          {'auth' in localStorage && localStorage.getItem('auth') === 'true' && (
            <Button
              className={classes.active}
              onClick={() => {
                localStorage.clear();
                navigate('/', true);
              }}
            >
              {' '}
              Logout{' '}
            </Button>
          )}
          {/* {<Button className={classes.active} onClick={() => handleRoute('Search')}> Search </Button>} */}
          {/* {<Button className={classes.active} onClick={() => handleRoute('Template')}> Manage Templates </Button>} */}
        </Toolbar>
      </AppBar>
    </div>
  );
}
